import React, { Component, useState } from "react";
import Map from "@zeliot/core/base/modules/TrackingControls/Maps/Map";

import withGoogleMaps from "@zeliot/common/hoc/withGoogleMaps";
import { withApollo } from "@apollo/client/react/hoc";

import {
  Grid,
  Paper,
  Button,
  Modal,
  Typography,
  withStyles,
  CircularProgress,
  Divider,
  Tooltip,
  Zoom,
} from "@material-ui/core";
import { ColorButton } from "@zeliot/common/ui/PaletteComponent";
import { Link, Switch } from "react-router-dom";
import { withRouter } from "src/components/scrollTop/withRouter";
import getMultiLine from "@zeliot/core/base/modules/TripsModule/MapUtils/MultiLine";
import { Maximize2 } from "lucide-react";
import { useTranslation } from "src/pages";

/**
 * @summary Area fence
 */
let fence = null;
/**
 * @summary Area marker
 */
let marker = null;
/**
 * @summary Polygon fence in LatLng object format
 */
let polygonCoordinates = [];
/**
 * @summary radius of area
 */
let savedRadius = 0;
/**
 * @summary Type of area
 */
let savedAreaType = "Circle";
/**
 * @summary stores polygon fence in LatLng object format temporarily during edit
 */
let savedPolygonCoordinates = null;
/**
 * @summary Index to monitor progress of animation
 */
let count = 0;
/**
 * @summary Vehicle icon
 */
let markerInstance = null;
/**
 * @summary Animation loop
 */
let loop = null;
/**
 * @summary Flag to monitor if animation is active
 */
let isAnimationActive = false;
/**
 * @summary Center of polygon fences
 */
let polygonCenter = null;
/**
 * @summary Custom marker object
 */
let CustomMarker;
/**
 * @summary Custom multicolour polyline object
 */
let MultiLine;
/**
 * @summary Custom popup object
 */
let CustomPopup;

const WOURI_GEOJSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: "Q769841",
      properties: {
        name: "Departement du Wouri",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [9.205217248, 3.743706184],
              [9.337254686, 3.918281446],
              [9.33861004, 3.917302859],
              [9.339539174, 3.91848412],
              [9.349805245, 3.909814382],
              [9.354914518, 3.90776484],
              [9.36211407, 3.913881952],
              [9.368382392, 3.913993683],
              [9.371628452, 3.916673797],
              [9.376273787, 3.917120468],
              [9.380135581, 3.919242263],
              [9.382114045, 3.92777655],
              [9.387325745, 3.935988719],
              [9.387483073, 3.938814762],
              [9.384586036, 3.94032736],
              [9.387226084, 3.943317017],
              [9.387086861, 3.947529091],
              [9.388660982, 3.948488735],
              [9.393558025, 3.948575991],
              [9.394520016, 3.950931473],
              [9.39478237, 3.955380755],
              [9.393208248, 3.957300043],
              [9.393865054, 3.962226591],
              [9.399254367, 3.96491802],
              [9.404667986, 3.972202648],
              [9.401961135, 3.990916253],
              [9.404101454, 3.993490922],
              [9.409326145, 3.99443288],
              [9.41096288, 3.995814469],
              [9.414299129, 4.002219668],
              [9.421916099, 4.008561919],
              [9.423804542, 4.013585529],
              [9.434568833, 4.023255982],
              [9.437338633, 4.023946651],
              [9.448902056, 4.02263438],
              [9.451038519, 4.023255982],
              [9.452641055, 4.029028263],
              [9.453264166, 4.055224896],
              [9.454777518, 4.059220968],
              [9.457448328, 4.060996926],
              [9.46154339, 4.060552937],
              [9.464748295, 4.057977764],
              [9.467597052, 4.057444927],
              [9.470890889, 4.058244141],
              [9.476855451, 4.062151366],
              [9.480416419, 4.061529764],
              [9.491010223, 4.052294499],
              [9.495639548, 4.050518457],
              [9.500268789, 4.051672897],
              [9.504369467, 4.055325898],
              [9.506950339, 4.060817889],
              [9.507371278, 4.064536771],
              [9.505985666, 4.069311187],
              [9.506247852, 4.073220842],
              [9.508676425, 4.072905766],
              [9.513484955, 4.077929879],
              [9.515593758, 4.076726741],
              [9.517173076, 4.077841031],
              [9.519273581, 4.077637099],
              [9.519193953, 4.075893999],
              [9.526350254, 4.071029561],
              [9.528017331, 4.072744079],
              [9.529694885, 4.071700868],
              [9.531924052, 4.072754892],
              [9.534253048, 4.075814538],
              [9.537410762, 4.07497794],
              [9.538908189, 4.076979874],
              [9.547718743, 4.077641625],
              [9.547886632, 4.079477681],
              [9.550213784, 4.079309289],
              [9.55403962, 4.083312737],
              [9.560024885, 4.084644119],
              [9.56434517, 4.082137175],
              [9.56667274, 4.081968448],
              [9.570826393, 4.07862717],
              [9.569490988, 4.070782546],
              [9.572479472, 4.065772934],
              [9.574640075, 4.065270439],
              [9.577799885, 4.067605386],
              [9.586609432, 4.06693123],
              [9.585451053, 4.07360884],
              [9.587279817, 4.074442337],
              [9.588114152, 4.078113946],
              [9.587084351, 4.081957719],
              [9.587698242, 4.082615363],
              [9.58874137, 4.081352126],
              [9.590108961, 4.083066226],
              [9.593126195, 4.082566664],
              [9.593528274, 4.086448826],
              [9.595481174, 4.085000434],
              [9.59535729, 4.083697048],
              [9.596371081, 4.084076245],
              [9.59673804, 4.085401591],
              [9.598265894, 4.08578565],
              [9.597054793, 4.086977725],
              [9.597313793, 4.08917504],
              [9.598864697, 4.087814071],
              [9.603719076, 4.090309782],
              [9.603064617, 4.090700379],
              [9.603488322, 4.094528897],
              [9.601090427, 4.094994344],
              [9.601643046, 4.095989528],
              [9.602774939, 4.095786267],
              [9.602267917, 4.096714562],
              [9.598605026, 4.096208044],
              [9.596652964, 4.094539123],
              [9.592842551, 4.094843638],
              [9.595077166, 4.109117432],
              [9.601472558, 4.107649174],
              [9.602791032, 4.109478692],
              [9.602881892, 4.115775345],
              [9.604388623, 4.118822922],
              [9.609423045, 4.119661782],
              [9.61720757, 4.119321142],
              [9.62114807, 4.121592386],
              [9.625686368, 4.126001183],
              [9.629785286, 4.135172075],
              [9.631287659, 4.136376219],
              [9.636838825, 4.137004024],
              [9.640107349, 4.136162649],
              [9.641877187, 4.134570757],
              [9.647712836, 4.124050296],
              [9.651124438, 4.120789735],
              [9.670350429, 4.120613967],
              [9.67655178, 4.119644767],
              [9.685563918, 4.122962073],
              [9.6947618, 4.121674529],
              [9.696464499, 4.125123682],
              [9.700562831, 4.12724246],
              [9.711155461, 4.128623127],
              [9.712078057, 4.13009985],
              [9.710940884, 4.134808384],
              [9.714824639, 4.137121874],
              [9.717421018, 4.143371169],
              [9.72430893, 4.14989866],
              [9.730088672, 4.149179241],
              [9.733779391, 4.151940073],
              [9.736815652, 4.152828135],
              [9.74422165, 4.148935579],
              [9.75010868, 4.148644224],
              [9.754826518, 4.151982988],
              [9.751936689, 4.161535591],
              [9.750972351, 4.171419699],
              [9.757275542, 4.187486886],
              [9.760753697, 4.192302038],
              [9.765376484, 4.196009018],
              [9.767305076, 4.203361875],
              [9.767726937, 4.207821634],
              [9.760689659, 4.22188563],
              [9.76171728, 4.224380252],
              [9.764785644, 4.225236295],
              [9.769207852, 4.224310598],
              [9.776142536, 4.221097731],
              [9.787098857, 4.223708191],
              [9.792234197, 4.223226231],
              [9.84603118, 4.168361897],
              [9.849961119, 4.165365954],
              [9.849958772, 4.163092027],
              [9.861455055, 4.158232954],
              [9.863121042, 4.156077128],
              [9.86370635, 4.146502983],
              [9.861676086, 4.142436419],
              [9.857262176, 4.138731618],
              [9.852612482, 4.13730066],
              [9.85070342, 4.135028828],
              [9.848789161, 4.128209731],
              [9.836449659, 4.124453297],
              [9.829889227, 4.11883583],
              [9.828098265, 4.115726227],
              [9.827381194, 4.113692442],
              [9.827974716, 4.111657652],
              [9.83274008, 4.109737777],
              [9.837977763, 4.103988126],
              [9.835707357, 4.098365965],
              [9.836896498, 4.095612594],
              [9.835519854, 4.08969036],
              [9.836468685, 4.085381223],
              [9.838491239, 4.081789075],
              [9.838247996, 4.077361335],
              [9.839319622, 4.076522558],
              [9.843134478, 4.077356138],
              [9.84492108, 4.076397164],
              [9.846110892, 4.074840058],
              [9.846702989, 4.070890254],
              [9.84598357, 4.066702823],
              [9.823662479, 4.052028122],
              [9.820876082, 4.04807245],
              [9.82054198, 4.045710179],
              [9.822313746, 4.042250548],
              [9.841775855, 4.033453322],
              [9.843459779, 4.027432181],
              [9.843707046, 4.010100669],
              [9.845169855, 4.002914528],
              [9.84730196, 4.000731964],
              [9.859469298, 3.996538833],
              [9.862096271, 3.99286932],
              [9.864412023, 3.983142792],
              [9.862607818, 3.972925252],
              [9.862686943, 3.962292137],
              [9.861798294, 3.959406332],
              [9.855528295, 3.95153606],
              [9.846134948, 3.945021896],
              [9.838794747, 3.941115929],
              [9.835754547, 3.94046826],
              [9.823294848, 3.947054843],
              [9.817045888, 3.948633491],
              [9.810784774, 3.94801499],
              [9.797793495, 3.950720417],
              [9.781765368, 3.961860637],
              [9.77480646, 3.96296512],
              [9.772123329, 3.962353576],
              [9.767924499, 3.958172096],
              [9.763111945, 3.949586178],
              [9.759456933, 3.945101524],
              [9.753021475, 3.940631036],
              [9.725926889, 3.938707976],
              [9.700627288, 3.92860728],
              [9.671500929, 3.925318221],
              [9.659753859, 3.913368896],
              [9.662517875, 3.896593439],
              [9.673573941, 3.857985639],
              [9.680872986, 3.837955824],
              [9.687407518, 3.828699772],
              [9.694411017, 3.812773737],
              [9.698971443, 3.796847534],
              [9.701176051, 3.770201548],
              [9.69347568, 3.754775158],
              [9.688379483, 3.751831098],
              [9.680998044, 3.749261626],
              [9.676701983, 3.746497693],
              [9.670992818, 3.740716862],
              [9.661600225, 3.744786527],
              [9.640657537, 3.74532188],
              [9.615766637, 3.750289331],
              [9.599119674, 3.778651596],
              [9.586252782, 3.797990993],
              [9.580726426, 3.794197092],
              [9.572149895, 3.800169366],
              [9.568249544, 3.801037144],
              [9.558969017, 3.811209757],
              [9.552939495, 3.815373971],
              [9.550280085, 3.818423558],
              [9.540530255, 3.820913822],
              [9.537205657, 3.825851517],
              [9.53746843, 3.828487542],
              [9.534375926, 3.830575055],
              [9.534188172, 3.829504518],
              [9.539732298, 3.821023541],
              [9.414184464, 3.657554971],
              [9.28768805, 3.715703335],
              [9.205217248, 3.743706184],
            ],
          ],
        ],
      },
    },
  ],
};

const MOUNGO_GEOJSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: "Q2445609",
      properties: {
        name: "Departement du Moungo",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [9.410777053, 4.222737818],
              [9.412674967, 4.226676893],
              [9.416868182, 4.227636956],
              [9.415128937, 4.233921623],
              [9.41659686, 4.236147773],
              [9.418937758, 4.236789156],
              [9.423403552, 4.234467369],
              [9.425624756, 4.237090989],
              [9.425196525, 4.242569568],
              [9.420928124, 4.248558019],
              [9.423032736, 4.254461645],
              [9.420926448, 4.261443183],
              [9.422900638, 4.265829769],
              [9.422042331, 4.27219574],
              [9.426957479, 4.278475294],
              [9.429928025, 4.289014364],
              [9.430114942, 4.29569977],
              [9.432448799, 4.296005374],
              [9.436998328, 4.293486445],
              [9.437180635, 4.296631838],
              [9.434433885, 4.301672379],
              [9.437800644, 4.303935996],
              [9.442829199, 4.304025431],
              [9.44204415, 4.309444499],
              [9.451559538, 4.309130094],
              [9.451520478, 4.315412498],
              [9.45628844, 4.317461538],
              [9.455194434, 4.321163573],
              [9.456489187, 4.324814143],
              [9.454303941, 4.335584889],
              [9.45148058, 4.338379164],
              [9.456798395, 4.339644747],
              [9.457924839, 4.341482647],
              [9.452859068, 4.346144243],
              [9.452489929, 4.348747075],
              [9.454851028, 4.350102094],
              [9.46142135, 4.347014955],
              [9.463453291, 4.347364229],
              [9.462722976, 4.354205287],
              [9.471437892, 4.363303172],
              [9.47588315, 4.363087087],
              [9.477962952, 4.364743099],
              [9.477564057, 4.377028287],
              [9.475954732, 4.381285875],
              [9.481737575, 4.380772399],
              [9.484291792, 4.385154375],
              [9.494484857, 4.389089175],
              [9.496403726, 4.391561753],
              [9.496731374, 4.399954636],
              [9.499863943, 4.412386088],
              [9.502527796, 4.412706361],
              [9.511350419, 4.403134898],
              [9.512673754, 4.403855323],
              [9.508272584, 4.416213852],
              [9.504568119, 4.418337323],
              [9.49648436, 4.418116376],
              [9.49481569, 4.420682077],
              [9.495485824, 4.426969762],
              [9.493556142, 4.434177025],
              [9.494655093, 4.442109239],
              [9.492050081, 4.451352718],
              [9.492272286, 4.460585971],
              [9.484655734, 4.470946758],
              [9.485878821, 4.474176976],
              [9.48933359, 4.474070023],
              [9.491423367, 4.476919367],
              [9.491565188, 4.478562387],
              [9.488016626, 4.482121427],
              [9.489074338, 4.484589646],
              [9.49514183, 4.484929616],
              [9.501330944, 4.49126382],
              [9.499796469, 4.496029352],
              [9.489226218, 4.50182594],
              [9.489780346, 4.506585939],
              [9.497262116, 4.509516169],
              [9.501028022, 4.513965535],
              [9.499826392, 4.519773272],
              [9.494204482, 4.523901694],
              [9.493925532, 4.526810717],
              [9.506521186, 4.53246867],
              [9.505534133, 4.529270722],
              [9.508538123, 4.527880332],
              [9.509139022, 4.525131655],
              [9.507765731, 4.523741265],
              [9.503506383, 4.523762638],
              [9.501650294, 4.521056625],
              [9.509419061, 4.518470556],
              [9.512202691, 4.520187589],
              [9.51137062, 4.543206558],
              [9.514245948, 4.545709227],
              [9.522228118, 4.547356187],
              [9.530918559, 4.562500274],
              [9.536207959, 4.565526896],
              [9.535285195, 4.570842196],
              [9.53634735, 4.578435446],
              [9.540435037, 4.579740257],
              [9.542580552, 4.58595636],
              [9.541293343, 4.590712755],
              [9.54488742, 4.590947951],
              [9.550002141, 4.588354087],
              [9.550412854, 4.592637743],
              [9.553148624, 4.59774953],
              [9.559328517, 4.600273489],
              [9.560806666, 4.603905786],
              [9.570515256, 4.608085339],
              [9.575280284, 4.616482665],
              [9.57919413, 4.618729266],
              [9.600329351, 4.620578649],
              [9.604946187, 4.621699896],
              [9.60800139, 4.624497524],
              [9.611626899, 4.624087398],
              [9.632800927, 4.628999528],
              [9.635633759, 4.636297065],
              [9.64498746, 4.639471962],
              [9.644454455, 4.643254044],
              [9.648362517, 4.65241756],
              [9.64345089, 4.655126591],
              [9.639216436, 4.654651756],
              [9.639150387, 4.660683374],
              [9.635062868, 4.664564446],
              [9.634720718, 4.666926299],
              [9.654728154, 4.687212265],
              [9.664360218, 4.694455319],
              [9.672362169, 4.705146436],
              [9.682901993, 4.712938924],
              [9.69259667, 4.722551039],
              [9.698858455, 4.745473868],
              [9.701201364, 4.774192448],
              [9.707189731, 4.797809382],
              [9.705483427, 4.808988577],
              [9.711658627, 4.81589887],
              [9.719979677, 4.82184977],
              [9.730514891, 4.823082999],
              [9.745537441, 4.836757068],
              [9.751522623, 4.844600518],
              [9.750491649, 4.850609253],
              [9.744688019, 4.856862488],
              [9.745956872, 4.860522949],
              [9.755140085, 4.868507047],
              [9.768360525, 4.869784533],
              [9.776802527, 4.875997367],
              [9.773370054, 4.879064892],
              [9.76519686, 4.878332482],
              [9.765892474, 4.881849947],
              [9.764408626, 4.888098321],
              [9.767465338, 4.890559834],
              [9.771856533, 4.890793941],
              [9.774925651, 4.893734229],
              [9.777932072, 4.893635238],
              [9.781397235, 4.897819484],
              [9.782537425, 4.90361029],
              [9.786705494, 4.907195481],
              [9.78660533, 4.913681398],
              [9.788327895, 4.917412937],
              [9.786743967, 4.919856095],
              [9.783094486, 4.921080942],
              [9.775732577, 4.920945993],
              [9.766100764, 4.917893975],
              [9.758945385, 4.920845997],
              [9.756337859, 4.925946888],
              [9.759556342, 4.933769551],
              [9.754224697, 4.940399552],
              [9.758272318, 4.943123336],
              [9.758897357, 4.946976161],
              [9.762515489, 4.949556866],
              [9.767069796, 4.956492052],
              [9.766134376, 4.962716034],
              [9.772092987, 4.976830237],
              [9.773524784, 4.986856418],
              [9.772754738, 5.001863797],
              [9.774822554, 5.005164171],
              [9.781915488, 5.009248338],
              [9.78685092, 5.01513017],
              [9.808796167, 5.024964238],
              [9.812793497, 5.024672129],
              [9.820837023, 5.015878171],
              [9.827995084, 5.014529188],
              [9.84077053, 5.020376152],
              [9.854622379, 5.018443956],
              [9.86513756, 5.029175642],
              [9.863037474, 5.034639385],
              [9.855682774, 5.044744859],
              [9.853625855, 5.050587633],
              [9.850049045, 5.053081081],
              [9.844550852, 5.055170438],
              [9.840994075, 5.05479233],
              [9.830367163, 5.059640339],
              [9.823478999, 5.072338168],
              [9.815122828, 5.080126884],
              [9.811914571, 5.091212454],
              [9.811221387, 5.09994866],
              [9.806180175, 5.105842647],
              [9.803788148, 5.111183177],
              [9.802396249, 5.12446799],
              [9.804261139, 5.126906873],
              [9.799732564, 5.136146999],
              [9.80070453, 5.140142149],
              [9.790338546, 5.144893934],
              [9.773579936, 5.145079928],
              [9.771139964, 5.159329918],
              [9.773049949, 5.178609972],
              [9.764853537, 5.18777399],
              [9.766127251, 5.198202168],
              [9.763899928, 5.205089996],
              [9.76398995, 5.210689946],
              [9.757659936, 5.221549959],
              [9.747619925, 5.23080995],
              [9.74632995, 5.236869982],
              [9.743859971, 5.238609982],
              [9.743349932, 5.24130996],
              [9.741239956, 5.24231998],
              [9.739218827, 5.241136036],
              [9.738629999, 5.243649936],
              [9.735764226, 5.243401077],
              [9.735614693, 5.245462271],
              [9.73974102, 5.259767665],
              [9.739878148, 5.275037398],
              [9.744652396, 5.274050764],
              [9.760159839, 5.264194735],
              [9.763626929, 5.265623263],
              [9.767274734, 5.265024963],
              [9.769849654, 5.267546323],
              [9.771652183, 5.267332668],
              [9.772772424, 5.263589729],
              [9.778069787, 5.265606918],
              [9.780407164, 5.268484761],
              [9.784332158, 5.268705959],
              [9.788932817, 5.272385782],
              [9.789532123, 5.274306076],
              [9.784875724, 5.276822994],
              [9.785914326, 5.278963062],
              [9.796371337, 5.280238285],
              [9.801950332, 5.283186787],
              [9.80418193, 5.281733868],
              [9.802937469, 5.278058822],
              [9.80418193, 5.275751117],
              [9.80688568, 5.276648651],
              [9.806327781, 5.281520297],
              [9.813365897, 5.281477465],
              [9.816670379, 5.276905053],
              [9.812893745, 5.275644331],
              [9.812636336, 5.27199066],
              [9.8146319, 5.271413733],
              [9.821669932, 5.273849598],
              [9.820189437, 5.275836696],
              [9.823043223, 5.282941029],
              [9.821852323, 5.282695356],
              [9.818699218, 5.287539844],
              [9.812042562, 5.292343681],
              [9.81324042, 5.293110457],
              [9.820647592, 5.287424342],
              [9.823500456, 5.28922578],
              [9.8219001, 5.294237488],
              [9.824544171, 5.29467628],
              [9.826415682, 5.2899856],
              [9.829355132, 5.290808367],
              [9.828836879, 5.294745934],
              [9.826068839, 5.295643384],
              [9.827560147, 5.298121746],
              [9.825553855, 5.29968145],
              [9.825961551, 5.301721941],
              [9.823858699, 5.301989072],
              [9.824706277, 5.303345767],
              [9.827066537, 5.302790298],
              [9.828351986, 5.299378193],
              [9.827128144, 5.308118842],
              [9.825661143, 5.308356049],
              [9.826902671, 5.309848699],
              [9.823497942, 5.329851356],
              [9.833314072, 5.331633181],
              [9.839299673, 5.335023242],
              [9.850274686, 5.333337557],
              [9.849874869, 5.331190533],
              [9.854528166, 5.327282051],
              [9.852945747, 5.326108585],
              [9.853941266, 5.324376381],
              [9.850617589, 5.317443793],
              [9.851873282, 5.315781242],
              [9.84970765, 5.313090484],
              [9.851025621, 5.309361375],
              [9.842532573, 5.3027877],
              [9.840684447, 5.303259098],
              [9.838747641, 5.301697885],
              [9.838879069, 5.298143119],
              [9.83641546, 5.295670626],
              [9.837857148, 5.293066033],
              [9.832950968, 5.288299329],
              [9.834456023, 5.281338577],
              [9.831634423, 5.276571118],
              [9.834005496, 5.274196776],
              [9.832487365, 5.273563775],
              [9.835070333, 5.27021445],
              [9.835488757, 5.266817181],
              [9.839286765, 5.265564422],
              [9.844431242, 5.26013714],
              [9.853100142, 5.257776125],
              [9.855578419, 5.255041026],
              [9.857375583, 5.25769063],
              [9.862037262, 5.257006834],
              [9.862788281, 5.255639327],
              [9.864671191, 5.256018692],
              [9.864655098, 5.25778677],
              [9.872084817, 5.254271819],
              [9.875625333, 5.256056075],
              [9.881247243, 5.253614762],
              [9.883494934, 5.257038937],
              [9.887459239, 5.259090156],
              [9.890133988, 5.267190595],
              [9.896424187, 5.274066941],
              [9.896106681, 5.275569984],
              [9.898704317, 5.276086057],
              [9.898237947, 5.277311659],
              [9.899559438, 5.276227963],
              [9.902280288, 5.278188825],
              [9.903796155, 5.277627657],
              [9.904437454, 5.280446575],
              [9.905733045, 5.280659475],
              [9.904832661, 5.281388366],
              [9.910386594, 5.281043366],
              [9.91232449, 5.282261676],
              [9.914953558, 5.279276377],
              [9.918365076, 5.280787132],
              [9.922329716, 5.27676474],
              [9.922536666, 5.278412958],
              [9.924394431, 5.279045624],
              [9.92543035, 5.278154041],
              [9.931194836, 5.279768227],
              [9.930896441, 5.281796229],
              [9.934074188, 5.282973551],
              [9.933836477, 5.273925538],
              [9.927411664, 5.264361787],
              [9.922771862, 5.250487977],
              [9.931082686, 5.253272948],
              [9.940615257, 5.249293136],
              [9.94598504, 5.252525031],
              [9.950806478, 5.24752665],
              [9.951939544, 5.248892565],
              [9.958119353, 5.246002569],
              [9.962904498, 5.246534065],
              [9.964763185, 5.243969957],
              [9.965967497, 5.245203941],
              [9.968550464, 5.244028798],
              [9.97234579, 5.244715192],
              [9.97419115, 5.241638196],
              [9.976910826, 5.243240732],
              [9.976336917, 5.239405257],
              [9.978313118, 5.240011436],
              [9.978884932, 5.237802637],
              [9.979448279, 5.23926092],
              [9.981132623, 5.238881723],
              [9.980494341, 5.236221391],
              [9.982001742, 5.235826016],
              [9.982092938, 5.233523675],
              [9.979657492, 5.230799137],
              [9.984201154, 5.230019285],
              [9.987339338, 5.227043793],
              [9.988739451, 5.228400572],
              [9.988835927, 5.226359998],
              [9.989485022, 5.227396252],
              [9.99323475, 5.224394693],
              [9.991138687, 5.222535419],
              [9.991763139, 5.221096163],
              [9.994099762, 5.221231949],
              [9.992273429, 5.217574338],
              [9.994802082, 5.218335247],
              [9.994936695, 5.214244376],
              [9.997286227, 5.213859646],
              [9.999013569, 5.208474777],
              [9.999546826, 5.210949785],
              [10.000719454, 5.210686426],
              [10.000858929, 5.206551465],
              [10.002371779, 5.206594297],
              [10.002661457, 5.204403854],
              [10.004474547, 5.203816282],
              [10.002285864, 5.203217982],
              [10.005064633, 5.201508325],
              [10.001207784, 5.196575743],
              [10.003357994, 5.195086949],
              [10.002013955, 5.191753718],
              [10.006283697, 5.19280045],
              [10.008050937, 5.191131362],
              [10.006579327, 5.189673497],
              [10.008470032, 5.188502545],
              [10.006045399, 5.186876372],
              [10.008975796, 5.18455249],
              [10.006930193, 5.182957833],
              [10.008173984, 5.181099062],
              [10.00510319, 5.178884731],
              [10.007435873, 5.178246952],
              [10.0059506, 5.175431386],
              [10.008267442, 5.174685732],
              [10.004667498, 5.170003936],
              [10.000744265, 5.168876235],
              [10.004747294, 5.168161594],
              [10.003782621, 5.165545183],
              [10.000805453, 5.164590484],
              [10.00489909, 5.16315282],
              [10.001527218, 5.162782256],
              [10.001042325, 5.161400835],
              [10.004346471, 5.158694067],
              [10.00191069, 5.157031852],
              [10.006771021, 5.15513377],
              [10.003793852, 5.153729885],
              [10.004594576, 5.151528462],
              [10.007176956, 5.150596226],
              [10.005079888, 5.149034678],
              [10.003962832, 5.144963168],
              [9.996061966, 5.141809896],
              [9.994765788, 5.135684234],
              [9.990596294, 5.135081072],
              [9.992180139, 5.131534186],
              [9.991970591, 5.122158524],
              [9.998236483, 5.118887235],
              [9.998655746, 5.116706432],
              [10.000891954, 5.115685684],
              [10.000280997, 5.109882389],
              [10.001879929, 5.105104369],
              [10.000689196, 5.102325684],
              [10.00432954, 5.099106363],
              [10.002900677, 5.094972073],
              [10.005656479, 5.093311534],
              [10.004975952, 5.089143381],
              [10.00996352, 5.081075045],
              [10.008539351, 5.076380676],
              [10.009226499, 5.073745741],
              [10.006119244, 5.071976824],
              [10.005727558, 5.070129872],
              [10.008819474, 5.066560439],
              [10.016000083, 5.06847629],
              [10.019774454, 5.063957942],
              [10.023096286, 5.063034591],
              [10.028166164, 5.064431435],
              [10.030466996, 5.061985596],
              [10.038536757, 5.061018324],
              [10.042108538, 5.058671391],
              [10.04436964, 5.053300519],
              [10.047591141, 5.05091679],
              [10.049880741, 5.052799281],
              [10.055017172, 5.052811268],
              [10.05718557, 5.054717899],
              [10.065249967, 5.049349542],
              [10.071400272, 5.047386919],
              [10.071331792, 5.034911965],
              [10.072582455, 5.032232689],
              [10.068642039, 5.028580527],
              [10.068862651, 5.02130998],
              [10.06404423, 5.018494834],
              [10.066425528, 5.014364735],
              [10.066369454, 5.010816173],
              [10.070391258, 5.005964895],
              [10.069591792, 5.001861785],
              [10.072741125, 4.997356261],
              [10.071577968, 4.994230146],
              [10.074054988, 4.990493662],
              [10.073664559, 4.987226899],
              [10.079056386, 4.980742072],
              [10.085694518, 4.977086724],
              [10.094273731, 4.963498317],
              [10.10723274, 4.958734295],
              [10.108565882, 4.951296278],
              [10.104955796, 4.950282738],
              [10.104202096, 4.947008683],
              [10.109301142, 4.941998065],
              [10.101398265, 4.923835319],
              [10.104160773, 4.920503848],
              [10.103401121, 4.91581476],
              [10.09582036, 4.905417093],
              [10.089277027, 4.887215539],
              [10.065406038, 4.864733849],
              [10.063765029, 4.852627364],
              [10.057446918, 4.840048642],
              [10.052597148, 4.835868335],
              [10.041401943, 4.834751698],
              [10.037496647, 4.828110046],
              [10.037920436, 4.820067861],
              [10.044274589, 4.821286673],
              [10.042413136, 4.818547048],
              [10.040956697, 4.810232117],
              [10.049309095, 4.802960899],
              [10.04711639, 4.802295376],
              [10.046015343, 4.799013191],
              [10.049089154, 4.797434878],
              [10.046431085, 4.793751786],
              [10.045709571, 4.788232219],
              [10.046991667, 4.786719453],
              [10.050301429, 4.787569462],
              [10.054550132, 4.785377762],
              [10.052833434, 4.78040612],
              [10.05622383, 4.775776795],
              [10.061448773, 4.775210094],
              [10.057994088, 4.77121134],
              [10.058916768, 4.770730219],
              [10.056473024, 4.76535876],
              [10.050251724, 4.760820881],
              [10.043665225, 4.751329968],
              [10.032364743, 4.739931334],
              [10.020968791, 4.736214882],
              [10.008115143, 4.722400835],
              [10.006039364, 4.72204494],
              [10.005358419, 4.724193222],
              [9.99926444, 4.727855359],
              [10.000626918, 4.730159544],
              [9.999060592, 4.732896738],
              [9.991995653, 4.735404017],
              [9.988283476, 4.738483445],
              [9.976002647, 4.722901654],
              [9.972843172, 4.715987171],
              [9.971233679, 4.704882825],
              [9.968932763, 4.700255847],
              [9.96677677, 4.697319667],
              [9.960380958, 4.69371285],
              [9.958119353, 4.688878084],
              [9.959293993, 4.685390877],
              [9.951691356, 4.680537336],
              [9.95128433, 4.676662299],
              [9.94954584, 4.675676084],
              [9.949567884, 4.67276287],
              [9.946774699, 4.668032459],
              [9.941821246, 4.666244431],
              [9.925902586, 4.665355027],
              [9.922373219, 4.662914636],
              [9.920688959, 4.663281177],
              [9.919627894, 4.664869296],
              [9.921254989, 4.669939342],
              [9.920602877, 4.67672927],
              [9.925169421, 4.67992244],
              [9.930469718, 4.68875948],
              [9.91286529, 4.697444389],
              [9.899630684, 4.7079703],
              [9.894289987, 4.708003157],
              [9.874080967, 4.698170597],
              [9.858809978, 4.687160297],
              [9.840728955, 4.677739876],
              [9.836393584, 4.673037042],
              [9.82686227, 4.67003104],
              [9.820076197, 4.663978048],
              [9.81422697, 4.649964177],
              [9.809687667, 4.64791455],
              [9.798345862, 4.647901474],
              [9.795271883, 4.646578391],
              [9.771978071, 4.621866277],
              [9.758801971, 4.610694038],
              [9.758115996, 4.60398466],
              [9.759649297, 4.595711051],
              [9.758049695, 4.590874358],
              [9.759349393, 4.581716458],
              [9.761019068, 4.5793738],
              [9.759925816, 4.575368927],
              [9.760838354, 4.567694288],
              [9.756959461, 4.564602623],
              [9.756081792, 4.555525358],
              [9.764023896, 4.540533569],
              [9.77024704, 4.532984576],
              [9.765636072, 4.530703692],
              [9.769643124, 4.527827275],
              [9.771117082, 4.51871229],
              [9.776443698, 4.517644436],
              [9.775329156, 4.511704265],
              [9.779357331, 4.506712758],
              [9.777852695, 4.503926278],
              [9.773364773, 4.501034354],
              [9.774470849, 4.495650992],
              [9.772809137, 4.497571286],
              [9.770879874, 4.496095988],
              [9.775237039, 4.492464193],
              [9.771448335, 4.489290469],
              [9.774536144, 4.48880105],
              [9.779659582, 4.476604794],
              [9.775469553, 4.474526585],
              [9.764082821, 4.455259188],
              [9.761355853, 4.454320247],
              [9.763469433, 4.443837671],
              [9.774151918, 4.439681169],
              [9.785248887, 4.448396085],
              [9.792376522, 4.447134777],
              [9.79532033, 4.443198719],
              [9.802123586, 4.44489312],
              [9.80460882, 4.440822198],
              [9.808040371, 4.440544421],
              [9.808439182, 4.434374586],
              [9.811072692, 4.431497582],
              [9.816789653, 4.430126051],
              [9.821497098, 4.425392455],
              [9.826787671, 4.426008274],
              [9.827559644, 4.428415053],
              [9.831495618, 4.427654479],
              [9.833178369, 4.429855986],
              [9.832376724, 4.431454164],
              [9.83446826, 4.431316784],
              [9.837715494, 4.435935297],
              [9.839784399, 4.435846868],
              [9.843928663, 4.431612582],
              [9.846144419, 4.431769491],
              [9.846205188, 4.425915486],
              [9.849696167, 4.423604595],
              [9.852500584, 4.424138187],
              [9.851950899, 4.420572358],
              [9.854034556, 4.417043828],
              [9.85245507, 4.414329935],
              [9.854495728, 4.412573089],
              [9.853551926, 4.405534721],
              [9.855761731, 4.40241682],
              [9.851196863, 4.39891989],
              [9.853125874, 4.396139362],
              [9.851400124, 4.387752094],
              [9.854464129, 4.380913886],
              [9.85116015, 4.375964875],
              [9.860692637, 4.363324127],
              [9.85780767, 4.359061929],
              [9.848559832, 4.353764231],
              [9.847420899, 4.351649225],
              [9.848169319, 4.347781983],
              [9.845601523, 4.345148976],
              [9.838861467, 4.342717972],
              [9.836886691, 4.344195618],
              [9.833590675, 4.340953749],
              [9.825735742, 4.341839465],
              [9.824857738, 4.339627481],
              [9.821671022, 4.338520399],
              [9.828245284, 4.316936998],
              [9.825849652, 4.3119211],
              [9.828985993, 4.303284051],
              [9.826799825, 4.293329619],
              [9.830166584, 4.284635993],
              [9.82965512, 4.281354562],
              [9.827396449, 4.279479446],
              [9.819214119, 4.277561667],
              [9.817637399, 4.275217752],
              [9.816188419, 4.262390338],
              [9.81343027, 4.260394691],
              [9.800207399, 4.268143593],
              [9.797053792, 4.269038445],
              [9.792981025, 4.267819884],
              [9.783453818, 4.25855436],
              [9.786136027, 4.248582662],
              [9.784300726, 4.23771477],
              [9.775597461, 4.226343796],
              [9.761142198, 4.223649182],
              [9.76099015, 4.220740745],
              [9.767726937, 4.207821634],
              [9.767305076, 4.203361875],
              [9.765376484, 4.196009018],
              [9.757275542, 4.187486886],
              [9.750972351, 4.171419699],
              [9.751936689, 4.161535591],
              [9.754826518, 4.151982988],
              [9.753341161, 4.150690498],
              [9.75010868, 4.148644224],
              [9.74422165, 4.148935579],
              [9.736815652, 4.152828135],
              [9.730088672, 4.149179241],
              [9.722828351, 4.149256522],
              [9.717421018, 4.143371169],
              [9.714824639, 4.137121874],
              [9.710940884, 4.134808384],
              [9.712078057, 4.13009985],
              [9.711155461, 4.128623127],
              [9.700562831, 4.12724246],
              [9.696464499, 4.125123682],
              [9.6947618, 4.121674529],
              [9.685563918, 4.122962073],
              [9.67655178, 4.119644767],
              [9.651124438, 4.120789735],
              [9.640107349, 4.136162649],
              [9.631287659, 4.136376219],
              [9.625686368, 4.126001183],
              [9.62114807, 4.121592386],
              [9.61720757, 4.119321142],
              [9.604388623, 4.118822922],
              [9.601472558, 4.107649174],
              [9.595077166, 4.109117432],
              [9.592842551, 4.094843638],
              [9.596652964, 4.094539123],
              [9.602267917, 4.096714562],
              [9.602774939, 4.095786267],
              [9.601090427, 4.094994344],
              [9.603488322, 4.094528897],
              [9.603719076, 4.090309782],
              [9.598864697, 4.087814071],
              [9.597313793, 4.08917504],
              [9.598265894, 4.08578565],
              [9.596371081, 4.084076245],
              [9.593528274, 4.086448826],
              [9.593126195, 4.082566664],
              [9.587084351, 4.081957719],
              [9.588114152, 4.078113946],
              [9.587279817, 4.074442337],
              [9.585451053, 4.07360884],
              [9.586609432, 4.06693123],
              [9.577799885, 4.067605386],
              [9.574640075, 4.065270439],
              [9.572479472, 4.065772934],
              [9.569490988, 4.070782546],
              [9.570826393, 4.07862717],
              [9.560024885, 4.084644119],
              [9.55403962, 4.083312737],
              [9.550213784, 4.079309289],
              [9.547886632, 4.079477681],
              [9.547718743, 4.077641625],
              [9.538908189, 4.076979874],
              [9.537410762, 4.07497794],
              [9.534253048, 4.075814538],
              [9.529694885, 4.071700868],
              [9.528017331, 4.072744079],
              [9.525453977, 4.071224692],
              [9.519193953, 4.075893999],
              [9.519273581, 4.077637099],
              [9.517173076, 4.077841031],
              [9.515593758, 4.076726741],
              [9.513484955, 4.077929879],
              [9.507733544, 4.072729663],
              [9.506247852, 4.073220842],
              [9.508575758, 4.081197396],
              [9.510348698, 4.0828374],
              [9.508039232, 4.08449073],
              [9.510050973, 4.084565664],
              [9.517520338, 4.091308486],
              [9.520474791, 4.091722049],
              [9.523954874, 4.094569382],
              [9.525717169, 4.098647262],
              [9.529028021, 4.10036463],
              [9.528644046, 4.103785536],
              [9.53054305, 4.10538539],
              [9.533954736, 4.103122024],
              [9.538063964, 4.103550088],
              [9.541089496, 4.102094738],
              [9.545777997, 4.107148439],
              [9.548341686, 4.104476121],
              [9.550836056, 4.104521467],
              [9.552086888, 4.106063234],
              [9.55117259, 4.111441399],
              [9.555322722, 4.119730598],
              [9.554685781, 4.121960687],
              [9.550072717, 4.123807723],
              [9.549315579, 4.129660722],
              [9.544616181, 4.13383667],
              [9.546956157, 4.141373678],
              [9.54706705, 4.147757754],
              [9.538234787, 4.151196179],
              [9.537646545, 4.153184617],
              [9.54044828, 4.156977596],
              [9.538832333, 4.160630849],
              [9.529767891, 4.162262386],
              [9.526924666, 4.166867823],
              [9.525576856, 4.18627897],
              [9.529545268, 4.19538356],
              [9.526993146, 4.209513018],
              [9.522161566, 4.211336585],
              [9.518194159, 4.21071666],
              [9.516777953, 4.205559359],
              [9.510213749, 4.195148532],
              [9.499926891, 4.201558257],
              [9.497918419, 4.201134468],
              [9.491136035, 4.193650183],
              [9.484211829, 4.199203445],
              [9.464223755, 4.187485461],
              [9.459414387, 4.190937967],
              [9.452522954, 4.190482997],
              [9.455226537, 4.19546914],
              [9.451200876, 4.204070649],
              [9.448125975, 4.206382294],
              [9.435909687, 4.209808061],
              [9.430410823, 4.209882074],
              [9.425400456, 4.208528564],
              [9.420841874, 4.202061758],
              [9.418331075, 4.202600882],
              [9.410777053, 4.222737818],
            ],
          ],
        ],
      },
    },
  ],
};

const SANAGA_MARITINE_GEOJSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: "Q2445164",
      properties: {
        name: "Departement de la Sanaga-Maritine",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [9.414184464, 3.657554971],
              [9.539732298, 3.821023541],
              [9.534375926, 3.830575055],
              [9.540530255, 3.820913822],
              [9.550280085, 3.818423558],
              [9.568249544, 3.801037144],
              [9.580726426, 3.794197092],
              [9.586252782, 3.797990993],
              [9.615766637, 3.750289331],
              [9.640657537, 3.74532188],
              [9.661600225, 3.744786527],
              [9.670992818, 3.740716862],
              [9.680998044, 3.749261626],
              [9.69347568, 3.754775158],
              [9.701176051, 3.770201548],
              [9.698971443, 3.796847534],
              [9.694411017, 3.812773737],
              [9.680872986, 3.837955824],
              [9.673573941, 3.857985639],
              [9.659753859, 3.913368896],
              [9.671500929, 3.925318221],
              [9.700627288, 3.92860728],
              [9.725926889, 3.938707976],
              [9.753021475, 3.940631036],
              [9.759456933, 3.945101524],
              [9.767924499, 3.958172096],
              [9.77480646, 3.96296512],
              [9.781765368, 3.961860637],
              [9.797793495, 3.950720417],
              [9.823294848, 3.947054843],
              [9.835754547, 3.94046826],
              [9.855528295, 3.95153606],
              [9.862686943, 3.962292137],
              [9.864412023, 3.983142792],
              [9.862096271, 3.99286932],
              [9.859469298, 3.996538833],
              [9.845169855, 4.002914528],
              [9.841775855, 4.033453322],
              [9.820640048, 4.044390951],
              [9.823662479, 4.052028122],
              [9.84598357, 4.066702823],
              [9.866688129, 4.071381266],
              [9.878420949, 4.081994683],
              [9.895827647, 4.083302931],
              [9.910504779, 4.091179237],
              [9.925342759, 4.081815394],
              [9.945979089, 4.08983017],
              [9.957597077, 4.079927287],
              [9.96312796, 4.078127357],
              [9.989554927, 4.092220018],
              [9.997451853, 4.090197046],
              [10.005620269, 4.083626723],
              [10.017288717, 4.088778576],
              [10.029484218, 4.083561261],
              [10.036949476, 4.08578037],
              [10.041353664, 4.083549023],
              [10.045119988, 4.091068345],
              [10.052227339, 4.086336844],
              [10.056899998, 4.086637671],
              [10.062637076, 4.080635893],
              [10.069310328, 4.081748842],
              [10.070168635, 4.08602948],
              [10.065533862, 4.087741651],
              [10.064701287, 4.092107952],
              [10.072941033, 4.098614321],
              [10.068452021, 4.106576123],
              [10.072254388, 4.112483269],
              [10.085128991, 4.115565295],
              [10.087334856, 4.122157159],
              [10.107663235, 4.129104499],
              [10.12149547, 4.123698088],
              [10.127282336, 4.126047452],
              [10.129190644, 4.130409981],
              [10.141579852, 4.128141167],
              [10.156342646, 4.116506918],
              [10.157200953, 4.109144422],
              [10.191361651, 4.110000549],
              [10.203549525, 4.106062564],
              [10.207159024, 4.109931063],
              [10.223118922, 4.106918691],
              [10.229250535, 4.11033767],
              [10.232217059, 4.115779285],
              [10.238225123, 4.110514276],
              [10.26654925, 4.101953252],
              [10.264576318, 4.098234369],
              [10.273746958, 4.094043837],
              [10.276178381, 4.087929071],
              [10.280877024, 4.095815855],
              [10.28115304, 4.108401785],
              [10.290269282, 4.100712982],
              [10.289440982, 4.11106765],
              [10.291777941, 4.116179772],
              [10.29763446, 4.111875665],
              [10.300538622, 4.113343755],
              [10.305022353, 4.10800046],
              [10.310309826, 4.118475659],
              [10.316988778, 4.103767431],
              [10.31687185, 4.107206526],
              [10.320835233, 4.108855246],
              [10.323845174, 4.105674062],
              [10.328740038, 4.11818464],
              [10.339597788, 4.125555685],
              [10.347963262, 4.136267338],
              [10.36533308, 4.146889976],
              [10.369915718, 4.15414049],
              [10.365165023, 4.157329552],
              [10.359067356, 4.167481546],
              [10.359638835, 4.197809199],
              [10.363270629, 4.206519925],
              [10.379081246, 4.217978154],
              [10.381242268, 4.22694788],
              [10.399818661, 4.251920671],
              [10.40987552, 4.277147433],
              [10.418573169, 4.283508376],
              [10.424876779, 4.30092924],
              [10.429849427, 4.33017655],
              [10.432978895, 4.331303497],
              [10.43821113, 4.347847529],
              [10.447150933, 4.356521458],
              [10.449650165, 4.35448256],
              [10.448077133, 4.342281946],
              [10.45224537, 4.340599195],
              [10.460029392, 4.359487478],
              [10.473035423, 4.366999591],
              [10.483051798, 4.369133372],
              [10.496216163, 4.365757393],
              [10.51747443, 4.367772738],
              [10.529481087, 4.366364243],
              [10.529148996, 4.383756273],
              [10.524715891, 4.405028621],
              [10.529977799, 4.410194891],
              [10.533577072, 4.421793098],
              [10.546329467, 4.420928337],
              [10.551356681, 4.430967427],
              [10.563512285, 4.429745597],
              [10.571607275, 4.424942934],
              [10.582517998, 4.426833723],
              [10.593709851, 4.420947783],
              [10.61589809, 4.429393473],
              [10.625761075, 4.443010294],
              [10.637006153, 4.453225319],
              [10.645659797, 4.450499943],
              [10.650413929, 4.452054032],
              [10.652240765, 4.459225923],
              [10.642158341, 4.460484969],
              [10.643544121, 4.464532087],
              [10.656793647, 4.471247333],
              [10.662409438, 4.470429175],
              [10.676477541, 4.481068995],
              [10.680017721, 4.493846872],
              [10.683226733, 4.493336078],
              [10.685513651, 4.484471126],
              [10.689323059, 4.483354992],
              [10.693642756, 4.486063185],
              [10.694376843, 4.499854265],
              [10.698000591, 4.505181635],
              [10.697035751, 4.521694823],
              [10.72151929, 4.524153989],
              [10.725928758, 4.522230678],
              [10.727808567, 4.511151897],
              [10.723173877, 4.502605541],
              [10.737393441, 4.492000841],
              [10.744031154, 4.492173676],
              [10.747837376, 4.496808198],
              [10.776427964, 4.497443798],
              [10.786090454, 4.510809497],
              [10.780508526, 4.525420663],
              [10.776606079, 4.529457136],
              [10.781540757, 4.537297317],
              [10.776645642, 4.545665222],
              [10.781076232, 4.552399327],
              [10.778716726, 4.571935699],
              [10.783268268, 4.58692447],
              [10.779888097, 4.599315521],
              [10.784625633, 4.608263454],
              [10.813429959, 4.612518946],
              [10.831202863, 4.611761725],
              [10.877044078, 4.580975582],
              [10.880311763, 4.58342578],
              [10.88049868, 4.58964314],
              [10.886242798, 4.596570029],
              [10.890066622, 4.607433227],
              [10.921968481, 4.606290522],
              [10.923135158, 4.589803234],
              [10.91200684, 4.557542965],
              [10.911205363, 4.518425294],
              [10.907248266, 4.50928508],
              [10.90052774, 4.503082723],
              [10.888313463, 4.499611274],
              [10.892698624, 4.487323572],
              [10.890602896, 4.472859592],
              [10.892087918, 4.468137647],
              [10.900552634, 4.462555634],
              [10.900142089, 4.457053418],
              [10.912009187, 4.437331889],
              [10.917583488, 4.433290639],
              [10.926259596, 4.432618159],
              [10.939121124, 4.416233717],
              [10.93448635, 4.407504971],
              [10.940633973, 4.402092189],
              [10.939936599, 4.39218654],
              [10.94803687, 4.385308099],
              [10.946829876, 4.381446388],
              [10.969172677, 4.378702321],
              [10.971742234, 4.371288946],
              [10.970293841, 4.367352218],
              [10.974236688, 4.366956425],
              [10.97703155, 4.358569325],
              [10.974086484, 4.355755855],
              [10.976414642, 4.353241871],
              [10.971570572, 4.338360975],
              [10.976607761, 4.335889655],
              [10.976275167, 4.332813999],
              [10.980867025, 4.332525159],
              [10.987277588, 4.327031576],
              [10.984606024, 4.322549018],
              [10.988350472, 4.321971253],
              [10.989702221, 4.317199855],
              [10.997164127, 4.316659557],
              [10.998246566, 4.308613433],
              [11.000779325, 4.310669598],
              [11.003059957, 4.308217137],
              [11.004275082, 4.310680159],
              [11.007721134, 4.306806882],
              [11.012103444, 4.307839783],
              [11.013497774, 4.302556167],
              [11.016535878, 4.300727739],
              [11.015118918, 4.292657391],
              [11.019238456, 4.287729167],
              [11.018093068, 4.283401255],
              [11.025256662, 4.284163422],
              [11.026084878, 4.279025147],
              [11.029786494, 4.278149071],
              [11.034929294, 4.271420498],
              [11.037331967, 4.274743755],
              [11.038887145, 4.273873965],
              [11.039923987, 4.268737283],
              [11.035439417, 4.261483417],
              [11.039589884, 4.253632255],
              [11.043714032, 4.253173346],
              [11.043906983, 4.24873999],
              [11.049052969, 4.248292145],
              [11.051073091, 4.250436487],
              [11.054236338, 4.24581479],
              [11.059315268, 4.247174083],
              [11.060265692, 4.244678958],
              [11.065666152, 4.244971151],
              [11.068088522, 4.238701823],
              [11.070232781, 4.240332271],
              [11.077029247, 4.23330438],
              [11.076174377, 4.225314918],
              [11.071887452, 4.222324757],
              [11.077552362, 4.214423054],
              [11.073532066, 4.206169226],
              [11.072459182, 4.193457651],
              [11.070227584, 4.190761192],
              [11.038770637, 4.18117372],
              [11.004692752, 4.160583156],
              [10.990061637, 4.155193089],
              [10.976782356, 4.141048795],
              [10.95694172, 4.137503921],
              [10.918532655, 4.121960855],
              [10.883953532, 4.123818117],
              [10.866811786, 4.11767787],
              [10.84260552, 4.114873034],
              [10.837664388, 4.101142135],
              [10.826802867, 4.092407857],
              [10.808572646, 4.095245885],
              [10.799388847, 4.089734532],
              [10.794286698, 4.093610325],
              [10.777891193, 4.090624858],
              [10.756895196, 4.071315636],
              [10.728774162, 4.060331068],
              [10.716870435, 4.057328418],
              [10.711813716, 4.05987065],
              [10.691827655, 4.033075885],
              [10.70136668, 4.02815445],
              [10.702521539, 4.022184859],
              [10.701026542, 4.017499459],
              [10.695499264, 4.012822524],
              [10.698252719, 4.009618123],
              [10.698662427, 4.003012848],
              [10.69441079, 3.999398822],
              [10.692901461, 3.987894074],
              [10.668278195, 3.984108219],
              [10.645964144, 3.96795646],
              [10.644754971, 3.946647231],
              [10.647695594, 3.931297116],
              [10.641754668, 3.920706498],
              [10.64599214, 3.917501342],
              [10.651688481, 3.900654052],
              [10.65135639, 3.893408567],
              [10.656021254, 3.891907536],
              [10.655789579, 3.881891665],
              [10.661764618, 3.874980366],
              [10.661930999, 3.868183062],
              [10.668089351, 3.853678598],
              [10.667252418, 3.839162985],
              [10.659291622, 3.834859632],
              [10.653188758, 3.835493137],
              [10.644825127, 3.823711031],
              [10.646810716, 3.81566893],
              [10.644000599, 3.810851263],
              [10.645387385, 3.803613993],
              [10.655429324, 3.793880675],
              [10.649979076, 3.78925596],
              [10.648069343, 3.796878128],
              [10.644400081, 3.79722078],
              [10.646991095, 3.789609258],
              [10.642302593, 3.792205217],
              [10.629399659, 3.789744122],
              [10.627214246, 3.782862161],
              [10.62223506, 3.782097899],
              [10.624341684, 3.76451736],
              [10.618972153, 3.759861632],
              [10.618979445, 3.754580362],
              [10.614383228, 3.746172056],
              [10.609978538, 3.747509724],
              [10.608394023, 3.744870346],
              [10.609917518, 3.734667475],
              [10.606076678, 3.732933175],
              [10.606334171, 3.727997575],
              [10.597547254, 3.735920066],
              [10.589522084, 3.729057551],
              [10.591624936, 3.736273364],
              [10.585082693, 3.739292525],
              [10.583550565, 3.745789841],
              [10.573332271, 3.742386537],
              [10.572838744, 3.749827153],
              [10.569695195, 3.752450018],
              [10.575799819, 3.754162943],
              [10.579630098, 3.759655018],
              [10.574932795, 3.758020044],
              [10.561335672, 3.768339172],
              [10.549845256, 3.769867948],
              [10.547164137, 3.779422563],
              [10.5431425, 3.778658133],
              [10.540844349, 3.784199745],
              [10.535099141, 3.786683973],
              [10.534493884, 3.79060486],
              [10.528947076, 3.787928435],
              [10.524566274, 3.797002767],
              [10.520589229, 3.792874344],
              [10.512810823, 3.800319821],
              [10.513803324, 3.797354555],
              [10.508530017, 3.787800024],
              [10.504635534, 3.791450594],
              [10.502200088, 3.807936624],
              [10.491385337, 3.804982087],
              [10.489674172, 3.808910769],
              [10.491393719, 3.81448222],
              [10.48742648, 3.817710342],
              [10.484518966, 3.812004529],
              [10.48097845, 3.814188434],
              [10.47679412, 3.810350696],
              [10.464831552, 3.817603389],
              [10.469539834, 3.820711986],
              [10.467849372, 3.825202842],
              [10.461645087, 3.821821163],
              [10.455808517, 3.825867527],
              [10.44230636, 3.822811317],
              [10.442783794, 3.819209027],
              [10.440203425, 3.817828192],
              [10.43000575, 3.819123447],
              [10.423718652, 3.812646835],
              [10.414707687, 3.815525348],
              [10.408204755, 3.809938474],
              [10.404792985, 3.811158879],
              [10.403430423, 3.802905135],
              [10.397111138, 3.805613664],
              [10.395780763, 3.796883492],
              [10.388753375, 3.790272937],
              [10.386135539, 3.796706886],
              [10.377488097, 3.789630631],
              [10.379338822, 3.784459919],
              [10.386704168, 3.784716825],
              [10.377917251, 3.773294051],
              [10.370467751, 3.737570379],
              [10.365525445, 3.72756398],
              [10.366346117, 3.718185384],
              [10.368626079, 3.719395144],
              [10.371195635, 3.717312828],
              [10.370407066, 3.701440689],
              [10.37188228, 3.695803691],
              [10.375245771, 3.693389368],
              [10.371592518, 3.686595919],
              [10.368121823, 3.685193459],
              [10.35898622, 3.661938288],
              [10.353262386, 3.657323547],
              [10.353042444, 3.649582357],
              [10.342372533, 3.652012941],
              [10.339720834, 3.64906402],
              [10.34309673, 3.637740236],
              [10.338402948, 3.6340035],
              [10.334894534, 3.626240684],
              [10.337544641, 3.620437222],
              [10.334073024, 3.6138094],
              [10.335736077, 3.609794133],
              [10.330785474, 3.606485377],
              [10.330719676, 3.599093041],
              [10.327030381, 3.595820578],
              [10.330334863, 3.590520282],
              [10.325088462, 3.589192421],
              [10.32400485, 3.586162195],
              [10.326965924, 3.58123657],
              [10.322938588, 3.562643329],
              [10.318157634, 3.564607041],
              [10.30866253, 3.554766268],
              [10.301259633, 3.550986281],
              [10.297270434, 3.551745682],
              [10.294064021, 3.540192653],
              [10.281540033, 3.522609096],
              [10.270489331, 3.515798381],
              [10.256404633, 3.513054397],
              [10.241826659, 3.516361142],
              [10.230481586, 3.514277736],
              [10.22638317, 3.53338177],
              [10.232155284, 3.545053821],
              [10.216601573, 3.550092351],
              [10.213940822, 3.55463266],
              [10.199795941, 3.557579486],
              [10.19781228, 3.564232286],
              [10.200847367, 3.573534439],
              [10.200312099, 3.587297189],
              [10.192705354, 3.593079361],
              [10.184710024, 3.593718062],
              [10.173146686, 3.579716092],
              [10.160078963, 3.572745199],
              [10.157086456, 3.563913355],
              [10.15244942, 3.564592876],
              [10.147805175, 3.573912379],
              [10.127806624, 3.571904578],
              [10.120854339, 3.578056392],
              [10.117619595, 3.577151481],
              [10.111938676, 3.566491628],
              [10.110833354, 3.547769139],
              [10.109170469, 3.545713226],
              [10.101633377, 3.547410477],
              [10.096918054, 3.528204939],
              [10.083432159, 3.49539817],
              [10.075803956, 3.496511873],
              [10.065681132, 3.490344217],
              [10.069613166, 3.467057446],
              [10.067017039, 3.442666192],
              [10.074087175, 3.420899647],
              [10.065053662, 3.408695093],
              [10.051202567, 3.398044879],
              [10.051020177, 3.39172593],
              [10.056770917, 3.382734076],
              [10.056288119, 3.377603932],
              [10.047984084, 3.36843589],
              [10.03652158, 3.336387935],
              [10.013928328, 3.324753853],
              [9.994093644, 3.308300093],
              [9.979233284, 3.301725328],
              [9.967463918, 3.279906648],
              [9.94488743, 3.268255467],
              [9.938195318, 3.26045334],
              [9.910719356, 3.25734248],
              [9.900428139, 3.266255964],
              [9.896070974, 3.276645584],
              [9.893663188, 3.27629849],
              [9.711819727, 3.187853067],
              [9.698764578, 3.226388196],
              [9.628042353, 3.303130973],
              [9.590597542, 3.337389069],
              [9.527502347, 3.380896343],
              [9.508482048, 3.396609059],
              [9.484422969, 3.422290959],
              [9.457561064, 3.459143253],
              [9.443259694, 3.488282437],
              [9.433875482, 3.51934929],
              [9.429656871, 3.551523058],
              [9.430715756, 3.583953983],
              [9.437810451, 3.61788049],
              [9.414184464, 3.657554971],
            ],
          ],
        ],
      },
    },
  ],
};

class MapOverview extends Component {
  constructor(props) {
    super(props);
    MultiLine = getMultiLine(props.google);
    this.departments = this._buildDepartmentsFromAois();
    this.state = {
      map: null,
      area: {},
      drawShapeFn: null,
      drawAllAois: null,
      displayAoIs: this._computeDisplayAoIs(props),
    };
   
  }

  DEFAULT_MIN_ZOOM = 6;

  _setMapBounds = () => {
    if (!this.state.map || !this.departments || this.departments.length === 0) return;

    const bounds = new this.props.google.maps.LatLngBounds();

    this.departments.forEach((dept) => {
      dept.paths.forEach((p) => {
        bounds.extend(new this.props.google.maps.LatLng(p.lat || p.latitude, p.lng || p.longitude));
      });
    });

    this.state.map.fitBounds(bounds);
  };
 
  _normalizeName = (value) =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  _findAreaByName = (areas = [], name) => {
    const needle = this._normalizeName(name);
    if (!needle) return null;
    return (
      (Array.isArray(areas) ? areas : []).find((a) => {
        const node = this._normalizeName(a?.name);
        return node === needle || node.includes(needle) || needle.includes(node);
      }) || null
    );
  };

  _stripChildren = (node) => {
    if (!node) return node;
    return { ...node, children: [] };
  };

  _getRootAreas = (areas = []) => {
    const list = Array.isArray(areas) ? areas : [];
    const roots = list.filter((a) => a?.parentId == null);
    const source = roots.length > 0 ? roots : list;
    return source.map((node) => this._stripChildren(node));
  };

  _computeDisplayAoIs = (props) => {
    const allAreas = Array.isArray(props?.allAreas) ? props.allAreas : [];
    const zone = props?.zone;
    const siteArea = props?.site?.area;
    const zoneId = zone?.zone?.id ?? null;
    const siteAreaId = siteArea?.id ?? null;
    const siteAreaName = String(siteArea?.name || "").trim();
    const normalizedSiteName = this._normalizeName(siteAreaName);
    const isOverview =
      !siteAreaName ||
      normalizedSiteName === "overview" ||
      normalizedSiteName === "all" ||
      normalizedSiteName === "tous" ||
      normalizedSiteName === "tout";

    if (Array.isArray(zone?.zones) && zone.zones.length > 0) {
      return zone.zones.map((node) => this._stripChildren(node));
    }
    if (zone && zone.category === "administrative-zones" && Array.isArray(zone?.zones)) {
      return [];
    }
    if (zoneId && zone?.zone) {
      return [this._stripChildren(zone.zone)];
    }

    if (siteAreaId && !isOverview) {
      return [this._stripChildren(siteArea)];
    }
    if (!siteAreaId && !isOverview) {
      const matched = this._findAreaByName(allAreas, siteAreaName);
      if (matched) return [this._stripChildren(matched)];
    }

    return this._getRootAreas(allAreas);
  };

  

  setMap = (map) =>
    this.setState({ map }, () => {
      this.setState({ multiLine: new MultiLine(this.state.map) });
      this._drawDepartmentsIfReady();
      this._setMapBounds(); 
    });

  _buildPathsFromGeoJson = (geojson) => {
    const ring = geojson.features[0].geometry.coordinates[0][0];
    return ring.map(([lng, lat]) => ({ lat, lng }));
  };

  _buildDepartmentsFromAois = (allAreas = []) => {
    return allAreas
      .map((aoi) => {
        // metaData est une string → tableau de coordonnées
        let paths = [];
        try {
          const coordinates = JSON.parse(aoi.metaData);

          paths = coordinates.map(([lat, lng]) => ({
            latitude: lat,
            longitude: lng,
          }));
        } catch (e) {
          console.error("Erreur metaData AOI:", aoi.id, e);
        }

        return {
          id: aoi.id,
          name: aoi.name,
          paths,
          strokeColor: "#2F80ED",
          fillColor: "#2F80ED",
          fillOpacity: 0.22,
        };
      })
      .filter((dept) => dept.paths.length > 0);
  };

  _getBoundsCenter = (paths) => {
    let minLat = Infinity;
    let maxLat = -Infinity;
    let minLng = Infinity;
    let maxLng = -Infinity;

    paths.forEach((p) => {
      if (p.lat < minLat) minLat = p.lat;
      if (p.lat > maxLat) maxLat = p.lat;
      if (p.lng < minLng) minLng = p.lng;
      if (p.lng > maxLng) maxLng = p.lng;
    });

    return {
      lat: (minLat + maxLat) / 2,
      lng: (minLng + maxLng) / 2,
    };
  };

  _setDrawDepartments = (drawFn) => {
    this.drawDepartment = drawFn;
    this._drawDepartmentsIfReady();
  };

  _drawDepartmentsIfReady = () => {
    if (this.hasDrawnDepartments || !this.drawDepartment || !this.state.map) {
      return;
    }

    this.departments.forEach((dept) => {
      this.drawDepartment({
        type: "polygon",
        paths: dept.paths,
        editable: false,
        name: dept.name,
        id: dept.id,
        strokeColor: dept.strokeColor,
        fillColor: dept.fillColor,
        fillOpacity: dept.fillOpacity,
      });
    });

    this.hasDrawnDepartments = true;
    this._setMapBounds(); 
  };


  handleSetClearShape = (fn) => {
    this.clearShapeFn = fn; // Stocke la fonction du fils
  };
  handleSetClearMarker = (fn) => {
    this.clearMarkerFn = fn; // Stocke la fonction du fils
  };
  handleSetDrawShape = (fn) => {
    this.setState({ drawShapeFn: fn });
  };

  handleSetDrawAllAois = (fn) => {
    console.log("✅ Fonction drawAllAois transmise :", fn);
    this.setState({ drawAllAois: fn });
  };

  componentDidUpdate(prevProps) {
    const allAreasChanged = prevProps.allAreas !== this.props.allAreas;
  
    // Compare par ID si possible
    const siteAreaId = this.props.site?.area?.id ?? null;
    const prevSiteAreaId = prevProps.site?.area?.id ?? null;
    const siteAreaName = this.props.site?.area?.name ?? "";
    const prevSiteAreaName = prevProps.site?.area?.name ?? "";
    const siteAreaChanged = siteAreaId !== prevSiteAreaId || siteAreaName !== prevSiteAreaName;
    const zoneCategory = this.props.zone?.category ?? "";
    const prevZoneCategory = prevProps.zone?.category ?? "";
    const zoneLabel = this.props.zone?.label ?? this.props.zone?.value ?? "";
    const prevZoneLabel = prevProps.zone?.label ?? prevProps.zone?.value ?? "";
    const zoneIds = (this.props.zone?.zones || [])
      .map((z) => z?.id)
      .filter(Boolean)
      .sort()
      .join(",");
    const prevZoneIds = (prevProps.zone?.zones || [])
      .map((z) => z?.id)
      .filter(Boolean)
      .sort()
      .join(",");
    const zoneId = this.props.zone?.zone?.id ?? null;
    const prevZoneId = prevProps.zone?.zone?.id ?? null;
    const zoneSignature = `${zoneCategory}|${zoneLabel}|${zoneIds}|${zoneId || ""}`;
    const prevZoneSignature = `${prevZoneCategory}|${prevZoneLabel}|${prevZoneIds}|${prevZoneId || ""}`;
    const zoneChanged = zoneSignature !== prevZoneSignature;
  
    // On redraw si n'importe lequel change ou si zone disparait
    const zoneRemoved = (prevZoneIds && !zoneIds) || (prevZoneId && !zoneId) || (prevZoneCategory && !zoneCategory);
  
    if (allAreasChanged || siteAreaChanged || zoneChanged || zoneRemoved) {
      this.setState({ displayAoIs: this._computeDisplayAoIs(this.props) });
    }
  }
  
  
  
  componentDidMount() {
    // Expose les fonctions de dessin pour que le parent puisse y accéder
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(undefined);
    }
  }

  render() {
    const { t } = this.props;
    const { displayAoIs } = this.state;
    console.log(this.props?.zone?.zone)
      // Function to open modal with specific content

    
    return (
      <div className="glass-card p-5 animate-fade-in">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-foreground">Cartographie des zones</h3>
          <div className="flex items-center gap-2">
            <span className="status-badge status-active">{t("LEWOOMINING.map_live")}</span>
            <span className="text-xs text-muted-foreground">◉ 4 Active</span>
            <button className="p-1.5 rounded hover:bg-secondary"  onClick={this.props?.openModal}>
              <Maximize2 className="w-4 h-4 text-muted-foreground" />
            </button>
          </div>
        </div>

        {/* Map Container */}
        <div className="relative h-[31rem] rounded-xl overflow-hidden bg-gradient-to-br from-blue-900/50 to-blue-800/30 border border-border">
          <Map
            google={this.props.google}
            setMap={this.setMap}
            registerDrawFunction={this._setDrawDepartments}
            zoom={6}
            // center={{ lat: 7.3697, lng: 12.3547 }}
            setClearShape={this.handleSetClearShape}
            setClearMarkers={this.handleSetClearMarker}
            setDrawShape={this.handleSetDrawShape}
            setDrawAllAois={this.handleSetDrawAllAois}
            area={this.props.site?.area}
            aois={displayAoIs}
            containerClassName="google-map-list-aoi"
          
            
          />
        </div>

        {/* Legend Section */}
        <div className="mt-4">
          <h3 className="text-sm font-semibold text-foreground mb-3">Filtres appliqués</h3>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
            {/* Zones Selection */}
            <div className="bg-card border border-border rounded-xl p-3">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                <span className="text-xs font-medium text-muted-foreground uppercase">Régions</span>
              </div>
              <div className="flex flex-wrap gap-1">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">Region du centre</span>
              </div>
            </div>
            
            {/* Departments Selection */}
            <div className="bg-card border border-border rounded-xl p-3">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
                <span className="text-xs font-medium text-muted-foreground uppercase">Départements</span>
              </div>
              <div className="flex flex-wrap gap-1">
                <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">Département du Wouri</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">Département Moungo</span>
              </div>
            </div>
            
            {/* Arrondissements Selection */}
            <div className="bg-card border border-border rounded-xl p-3">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-3 h-3 rounded-full bg-purple-500"></div>
                <span className="text-xs font-medium text-muted-foreground uppercase">Arrondissements</span>
              </div>
              <div className="flex flex-wrap gap-1">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full">Bonanjo</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full">Akwa</span>
              </div>
            </div>
            
            {/* Districts Selection */}
            <div className="bg-card border border-border rounded-xl p-3">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <span className="text-xs font-medium text-muted-foreground uppercase">Groupements</span>
              </div>
              <div className="flex flex-wrap gap-1">
                <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">District 1</span>
                <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">District 2</span>
              </div>
            </div>
            
            {/* Quarters Selection */}
            <div className="bg-card border border-border rounded-xl p-3">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-3 h-3 rounded-full bg-pink-500"></div>
                <span className="text-xs font-medium text-muted-foreground uppercase">Quartiers</span>
              </div>
              <div className="flex flex-wrap gap-1">
                <span className="px-2 py-1 bg-pink-100 text-pink-800 text-xs rounded-full">Quarter A</span>
                <span className="px-2 py-1 bg-pink-100 text-pink-800 text-xs rounded-full">Quarter B</span>
              </div>
            </div>
            
            {/* Places Selection */}
            <div className="bg-card border border-border rounded-xl p-3">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-3 h-3 rounded-full bg-indigo-500"></div>
                <span className="text-xs font-medium text-muted-foreground uppercase">Lieux</span>
              </div>
              <div className="flex flex-wrap gap-1">
                <span className="px-2 py-1 bg-indigo-100 text-indigo-800 text-xs rounded-full">Hôpital</span>
                <span className="px-2 py-1 bg-indigo-100 text-indigo-800 text-xs rounded-full">École</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withGoogleMaps(withApollo(MapOverview)));

